import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { IOffer } from '../../Models';
import { OfferService } from '../../Services';

interface IEmployerOffersWidgetState {
    officialNameList: string[] | null;
    offerList: IOffer[];
    isLoading: boolean;
}

interface IEmployerOffersWidgetProps {
    officialName: string;
    dictOffers: string;
    dictPublished: string;
    dictToday: string;
    dictThe: string;
    dictRef: string;
    language: string;
    offerDetailPage: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
}

export class EmployerOffersWidget extends Component<
    IEmployerOffersWidgetProps,
    IEmployerOffersWidgetState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            officialNameList: this.props.officialName
                ? this.props.officialName.split('|')
                : null,
            offerList: [],
            isLoading: this.props.officialName ? true : false,
        };

        void this.getOffersForEmployer();
    }

    async getOffersForEmployer() {
        if (this.state.officialNameList) {
            const offerList = await OfferService.getAllOffersForEmployer(
                this.state.officialNameList
            );
            this.setState({ offerList, isLoading: false });
        }
    }

    render() {
        return (
            <>
                {this.state.isLoading && this.state.offerList.length == 0 && (
                    <div className="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                )}
                {this.state.offerList.length > 0 && (
                    <div className="lessmore">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-10 col-offset-lg-1">
                                    <h4>{this.props.dictOffers}</h4>
                                    <div className="featured-tiles">
                                        {this.state.offerList.map((offer) => {
                                            const today = new Date();
                                            const publishedDate = new Date(
                                                offer.dateModification
                                            );
                                            let isToday = false;
                                            if (
                                                publishedDate.getDate() ==
                                                    today.getDate() &&
                                                publishedDate.getMonth() ==
                                                    today.getMonth() &&
                                                publishedDate.getFullYear ==
                                                    today.getFullYear
                                            ) {
                                                isToday = true;
                                            }
                                            return (
                                                <a
                                                    key={offer.reference}
                                                    href={
                                                        this.props
                                                            .offerDetailPage +
                                                        '?reference=' +
                                                        offer.reference +
                                                        '&type=' +
                                                        offer.typeOffer
                                                    }
                                                    className="featured-tiles__tile"
                                                >
                                                    <article role="presentation">
                                                        <h3
                                                            className="title"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    this.props
                                                                        .language ===
                                                                    'fr'
                                                                        ? offer.titreFr ||
                                                                          offer.titreNl
                                                                        : offer.titreNl ||
                                                                          offer.titreFr,
                                                            }}
                                                        ></h3>
                                                        <ul className="under-title">
                                                            <li>
                                                                {
                                                                    this.props
                                                                        .dictRef
                                                                }{' '}
                                                                {
                                                                    offer.reference
                                                                }
                                                            </li>
                                                            {offer.codePays && (
                                                                <li>
                                                                    {
                                                                        offer.codePays
                                                                    }
                                                                </li>
                                                            )}
                                                            {offer.employeur && (
                                                                <li>
                                                                    {this.props
                                                                        .language ===
                                                                    'fr'
                                                                        ? offer
                                                                              .employeur
                                                                              .nomFr
                                                                            ? offer
                                                                                  .employeur
                                                                                  .nomFr
                                                                            : offer
                                                                                  .employeur
                                                                                  .nomNl
                                                                        : offer
                                                                                .employeur
                                                                                .nomNl
                                                                          ? offer
                                                                                .employeur
                                                                                .nomNl
                                                                          : offer
                                                                                .employeur
                                                                                .nomFr}
                                                                </li>
                                                            )}
                                                            <li className="state">
                                                                {
                                                                    this.props
                                                                        .dictPublished
                                                                }
                                                                {isToday
                                                                    ? ' ' +
                                                                      this.props
                                                                          .dictToday
                                                                    : ' ' +
                                                                      this.props
                                                                          .dictThe +
                                                                      ' ' +
                                                                      publishedDate.getDate() +
                                                                      ' ' +
                                                                      publishedDate.toLocaleString(
                                                                          this
                                                                              .props
                                                                              .language,
                                                                          {
                                                                              month: 'long',
                                                                          }
                                                                      ) +
                                                                      ' ' +
                                                                      publishedDate.getFullYear()}
                                                            </li>
                                                        </ul>
                                                        <div className="under-title"></div>
                                                    </article>
                                                </a>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

WidgetHelper.register(EmployerOffersWidget, 'employer-offers-widget');
